import styled from 'styled-components';

export const NewProjectContainer = styled.div``;

export const SendProjectBody = styled.div`
  width: 100%;
  height: 25.25rem;
  display: flex;
  justify-content: space-between;
`;

export const UploadedFilesList = styled.div`
  width: 100%;
  overflow-y: auto;
  border-right: 2px solid ${({ theme }) => theme.colors.gray2};
  color: ${({ theme }) => theme.colors.grayDark2};
  padding: 0.5rem 0;

  display: flex;
  flex-direction: column;

  & > div.file {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0.5rem;
    cursor: pointer;
    transition: background-color 0.25s ease-in;

    &.selected {
      background-color: #dce9ff;
    }

    & > span.filename {
      font-size: 1rem;
      margin-right: 0.5rem;
      color: ${({ theme }) => theme.colors.grayDark4};
      display: block;
      width: 99%;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    & > span.icon svg {
      width: 1rem;
      height: 1rem;
    }
  }
`;

export const SendProjectHeader = styled.header`
  & > .title {
    font-size: 1rem;
    color: ${({ theme }) => theme.colors.grayDark4};
    margin-bottom: 0.875rem;
  }

  & > .subtitle {
    margin-bottom: 0.875rem;
    & > span {
      color: ${({ theme }) => theme.colors.grayDark2};
      font-size: 1rem;
      &:last-child {
        font-weight: 600;
      }
    }
  }
`;

export const SendProjectContent = styled.div`
  width: 100%;
  margin-left: 1.5rem;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;

  & > span.required-fields-message {
    color: ${({ theme }) => theme.colors.grayDark4};
    font-size: 1rem;
    margin-bottom: 0.25rem;
  }
`;
